import { useMutation } from '@tanstack/react-query';
import { CUSTOMER_REQUESET_REGISTERATION, SET_DEFAULT_CAFETERIA } from '@/constants/API';
import { axios } from '@/lib/axios';
import { SelectCafeteriaCredentialsDTO, DefaultCafeteria } from '@/types/cafeteria';

export const selectCafeteria = async (payload: SelectCafeteriaCredentialsDTO) => {
  const { data } = await axios.post(CUSTOMER_REQUESET_REGISTERATION, payload);
  return data;
};

export const setDefaultCafeteria = async (payload: DefaultCafeteria) => {
  const { data } = await axios.post(SET_DEFAULT_CAFETERIA, payload);
  return data;
};

export const useSelectCafeteriaMutation = () => useMutation(selectCafeteria);

export const useSetDefaultCafeteriaMutation = () => useMutation(setDefaultCafeteria);
